module.exports = __webpack_public_path__ + "img/Standard.00fd4561.svg";